import Token from '@/di/di.token'

import useDi from '../useDi'

export default function useCartService() {
  const { container } = useDi()
  const service = container.get(Token.CART_SERVICE)
  return { service }
}
